module.exports = __webpack_public_path__ + "img/jboard_icon-42.dce6df7b.png";